import { Table, Pagination, Tooltip, Select, Modal } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import { changeLoader } from "../../../../redux/reducers/loader";
import toast from "react-hot-toast";
import { formatDateFunction } from "../../../../utils/helper/utils";
import AdminLogBodyData from "../../../../Modal/AdminLogBodyData";
import dayjs from "dayjs";

const { Option } = Select;

const AdminActivityLogsReports = ({ inputData, setInputData }) => {
  const dispatch = useDispatch();
  const [reportData, setReportData] = useState([]);
  const [paginator, setPaginator] = useState({
    itemCount: 0,
    perPage: 10,
    pageCount: 0,
    currentPage: 1,
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);

  const getReportData = async (page = 1, limit = 10) => {
    dispatch(changeLoader(true));
    try {
      let params = {
        page,
        limit,
        search: inputData.search,
        start_date: inputData.start_date,
        end_date: inputData.end_date,
      };
      
      if (inputData.method) {
        params.method = inputData.method;
      }

      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ADMIN_ACTIVITY_LOGS, "get", {}, { params }, true);
      let apiResponse = response.data;
      if (apiResponse?.status === "SUCCESS") {
        setReportData(apiResponse?.data?.data || []);
        if (apiResponse?.data?.paginator) {
          setPaginator(apiResponse.data.paginator);
        }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message || "Failed to fetch logs");
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getReportData(1, paginator.perPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData.search, inputData.start_date, inputData.end_date, inputData.method]);

  const onShowSizeChange = (current, pageSize) => {
    getReportData(current, pageSize);
  };

  const onPageChange = (page, pageSize) => {
    getReportData(page, pageSize);
  };

  const columns = [
    {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => text || "-"
  },
    // {
    //   title: "S. No.",
    //   dataIndex: "index",
    //   key: "index",
    //   render: (text, record, index) => (paginator.currentPage - 1) * paginator.perPage + index + 1,
    // },
    {
      title: "Date & Time",
      dataIndex: "dateTime",
      key: "dateTime",
      render: (text) => text ? dayjs(text).format("DD/MM/YYYY hh:mm A") : "N/A",
    },
    {
      title: "User Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Method",
      dataIndex: "method",
      key: "method",
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
    },
    {
      title: "Body Data",
      dataIndex: "body",
      key: "body",
      render: (text) => {
        const jsonStr = JSON.stringify(text || {});
        return (
          <Tooltip title={<div style={{ maxWidth: 400, wordWrap: "break-word" }}>Click to view full data</div>}>
            <span 
              style={{ cursor: "pointer", color: "#176B53" }}
              onClick={() => {
                setModalData(text || {});
                setIsModalVisible(true);
              }}
            >
              {jsonStr.length > 50 ? jsonStr.substring(0, 50) + "..." : jsonStr}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Status Code",
      dataIndex: "statusCode",
      key: "statusCode",
    },
    {
      title: "Message",
      dataIndex: "responseMessage",
      key: "responseMessage",
    },
  ];

  return (
    <>
      <div className="filter-section" style={{ marginBottom: 16 }}>
        {/* <Select
          placeholder="Select Method"
          allowClear
          style={{ width: 200 }}
          onChange={(val) => setInputData(prev => ({ ...prev, method: val }))}
          value={inputData.method}
        >
          <Option value="POST">POST</Option>
          <Option value="PUT">PUT</Option>
          <Option value="DELETE">DELETE</Option>
        </Select> */}
      </div>
      <Table 
        columns={columns} 
        dataSource={reportData} 
        pagination={false} 
        rowKey="id"
        scroll={{ x: true }}
      />
      {paginator.itemCount > 0 && (
        <Pagination
          className="mt-4 text-right"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          defaultCurrent={paginator.currentPage}
          current={paginator.currentPage}
          total={paginator.itemCount}
        />
      )}
      {/* Modal for Body Data */}
      <AdminLogBodyData
        isVisible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        data={modalData}
      />
    </>
  );
};

export default AdminActivityLogsReports;
